import { useSelector } from 'react-redux';
import { ButtonRoot, ButtonTitle } from './styles';

import { useState } from 'react';
import { getMode } from '@store/slices/configSlice';
import { MODE } from '@utils/constants';

interface MailToButtonProps {
  icon?: React.ReactNode;
  title: string;
  backgroundColor?: string;
  textColor?: string;
  href: string;
  borderRadius?: string;
  padding?: string;
  border?: string;
  width?: string;
  hoverBackgroundColor?: string;
  fontSize?: string;
  hoverTextColor?: string;
  lineHeight?: string;
  disabled?: boolean;
  testId?: string;
}

const MailToButton = ({
  href,
  icon,
  title,
  border,
  backgroundColor = 'grey',
  textColor,
  borderRadius,
  padding,
  width,
  hoverBackgroundColor,
  fontSize,
  hoverTextColor,
  lineHeight,
  disabled = false,
  testId = 'regular-button',
}: MailToButtonProps) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const mode = useSelector(getMode);
  return (
    <ButtonRoot
      href={href}
      $borderRadius={borderRadius}
      $padding={padding}
      $border={border}
      $backgroundColor={backgroundColor}
      $width={width}
      $hoverBackgroundColor={hoverBackgroundColor}
      $disabled={disabled}
      data-testid={testId}
      onMouseOver={() => {
        setIsHovered(true);
      }}
      onMouseOut={() => {
        setIsHovered(false);
      }}
    >
      <ButtonTitle
        $textColor={textColor}
        $hoverTextColor={hoverTextColor}
        $fontFamily={
          mode === MODE.EVENT ||
          mode === MODE.PORTFOLIO ||
          mode === MODE.WEBINAR
            ? 'Lato, Arial, sans-serif'
            : 'proxima-nova, sans-serif'
        }
        $fontSize={fontSize}
        $isHovered={isHovered}
        $lineHeight={lineHeight}
      >
        {icon || null}
        {title}
      </ButtonTitle>
    </ButtonRoot>
  );
};

export default MailToButton;
